// https://vuex.vuejs.org/zh-cn/getting-started.html
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {},
  state: {
    common: {},
  },
  getters: {},
  mutations: {
    setCommon (state, {key, value}) {
      Vue.set(state.common, key, JSON.parse(JSON.stringify(value))) // 必须使用set，才是响应式
    },
    setModule (state, {module, obj = {}}) {
      let tmp = state[module] ? state[module] : {}
      Vue.set(state, module, JSON.parse(JSON.stringify({...tmp, ...obj}))) // 必须使用set，才是响应式
    },
    setValue (state, {module = [], key, value}) {
      if(Object.prototype.toString.call(module) === '[object Array]' && module.length > 0) {
        let tmp = module.reduce((accumulator, currentValue) => {
          console.log(accumulator, currentValue)
          if(accumulator && accumulator[currentValue] !== undefined) return accumulator[currentValue]
          accumulator[currentValue] = {}
          return accumulator[currentValue]
        }, state)
        Vue.set(tmp, key, JSON.parse(JSON.stringify(value))) // 必须使用set，才是响应式
      } else {
        console.error('error module')
      }
    },
  },
  actions: {},
  strict: process.env.NODE_ENV !== 'production', // 严格模式
})



// WEBPACK FOOTER //
// ./src/store/index.js